import React, { useState } from 'react'
import { Col, Form, FormCheck } from 'react-bootstrap'
import { EmailOptIn } from '@srca-b2b/kp5-ui-common'
import { connect } from 'formik'
import PropTypes from 'prop-types'
import { useTranslation } from 'next-i18next'
import styles from './MarketingConsentForm.module.scss'
import classNames from 'classnames'

const MarketingConsentForm = ({ formik, name, id, country }) => {
  const { t } = useTranslation('common')

  const [modalVisibility, setModalVisibility] = useState(
    new Array(indentedConsent?.length).fill(false)
  )

  const toggleModalVisibility = (index) => {
    setModalVisibility((prevState) => {
      const updatedState = [...prevState]
      updatedState[index] = !updatedState[index]
      return updatedState
    })
  }
  const indentedConsent = [
    {
      label: t('Marketing_consent_first_checkbox_label'),
      linkID: 'ga-kp-getstarted-signin-companyinfo-agreement-detailspopup', // To be changed should PMs provide click ID
      ppID: 'ga-kp-getstarted-signin-companyinfo-agreement-detailspopup-Samsungknoxprivacypolicy' // To be changed should PMs provide click ID
    },
    {
      label: t('Marketing_consent_second_checkbox_label'),
      linkID: 'ga-kp-getstarted-signin-companyinfo-agreement-detailspopup', // To be changed should PMs provide click ID
      ppID: 'ga-kp-getstarted-signin-companyinfo-agreement-detailspopup-Samsungknoxprivacypolicy' // To be changed should PMs provide click ID
    }
  ]

  return (
    <div>
      <Form.Group as={Col} controlId={id} className="mx-auto mb-2">
        <FormCheck custom inline required>
          <FormCheck.Input
            isInvalid={formik.errors[name]}
            type={'checkbox'}
            name={name}
            id={id}
            checked={formik.values[name]}
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
          />
          <FormCheck.Label
            htmlFor={id}
            className={classNames('font-weight-normal', styles.textLabel)}
          >
            {t('Optional_marketing_consent_parent_checkbox_label')}
          </FormCheck.Label>
        </FormCheck>
      </Form.Group>
      {indentedConsent.map((value, index) => {
        return (
          <Form.Group as={Col} className={classNames(styles.indentedCheckbox, 'mb-2')} key={index}>
            <FormCheck custom inline required>
              <FormCheck.Input type={'checkbox'} checked={formik.values[name]} disabled={true} />
              <FormCheck.Label className={classNames('font-weight-normal', styles.textLabel)}>
                {value.label}{' '}
                <EmailOptIn
                  show={modalVisibility[index]}
                  setShow={() => toggleModalVisibility(index)}
                  linkText={t('Marketing_consent_details')}
                  linkId={value.linkID}
                  ppId={value.ppID}
                  country={country}
                />
              </FormCheck.Label>
            </FormCheck>
          </Form.Group>
        )
      })}
    </div>
  )
}

MarketingConsentForm.propTypes = {
  id: PropTypes.string.isRequired,
  optionText: PropTypes.string
}

export default connect(MarketingConsentForm)
